<div
  class="jsp-card"
  *ngIf="!loading && data"
  role="region"
  [attr.aria-label]="data?.tierName || 'Journey Select benefits'"
>
  <div class="jsp-card-content">
    <div class="jsp-badge fs-1 font600" *ngIf="data?.badgeLabel">
      {{ data.badgeLabel }}
    </div>

    <h2 class="jsp-tier-name font800" *ngIf="tierNameHighlight">
      <span class="lead" *ngIf="tierNameLead">{{ tierNameLead }} </span>
      <span class="highlight">{{ tierNameHighlight }}</span>
    </h2>

    <div
      class="fs-2 font500 ion-margin-bottom white-text-color"
      *ngIf="data?.tierSubtitle"
      [innerHTML]="data.tierSubtitle | safeHtml"
    ></div>

    <div
      class="jsp-chip-row d-flex"
      *ngIf="data?.campaigns?.length"
      role="list"
    >
      <label
        class="jsp-chip d-flex ion-align-items-center font600"
        *ngFor="let campaign of data.campaigns; trackBy: trackByCampaign"
        [attr.aria-label]="campaign?.title"
        [attr.title]="campaign?.subtitle || campaign?.title"
        role="listitem"
      >
        <span class="jsp-chip-label">{{ campaign?.title }}</span>
      </label>
    </div>

    <button
      type="button"
      class="jsp-cta-btn w100 d-flex ion-align-items-center ion-justify-content-center font18 font700 cursor-pointer"
      (click)="exploreCTA()"
      [attr.aria-label]="ctaLabel"
    >
      <span class="jsp-cta-label">{{ ctaLabel }}</span>
      <span class="jsp-cta-arrow" aria-hidden="true">→</span>
    </button>
  </div>
</div>
